
export default {
    name: 'tarif-chambre',
    components: {},
    props: {
        assurance_id: Number,
        fields: Array,
        assurance_select: Object,
        editing_chambre_tarif_data: Object
    },
    data() {
        return {
            is_printing: false,
            chambre_is_loading: true,
            chambre_is_empty: false,
            is_error_load: false,

			chambre_filter: "",
			perPage: 20,
			print_per_page: -1,
			currentPage: 1,
        }
    },

    watch: {
        assurance_select() {
            const data = {
                assurance_id: this.assurance_select.compagnie_id,
                data_type: 'chambre'
            }
            this.getListeChambre(data)
        },

        editing_chambre_tarif_data() {
            this.saveTarifChambre()
        }
    },

    computed: {
        tarif_chambres() {
            return this.$store.getters["tarif_chambres"];
        },

        chambre_length() {
            return this.tarif_chambres.length;
        },
    },

    mounted() {
        const data = {
            assurance_id: 0,
            data_type: 'chambre'
        }
        this.getListeChambre(data)
    },

    methods: {
        getListeChambre(data) {
            this.chambre_is_loading = true

            this.$store.dispatch('getTarificationTypeAdmission', data).then(() => {
                if (this.tarif_chambres.length > 0) {
                    this.chambre_is_empty = false
                } else {
                    this.chambre_is_empty = true
                }
                this.chambre_is_loading = false
            }).catch(() => {
                this.chambre_is_loading = false
                this.is_error_load = true
            })
        },

        edit(data, type_prestation) {
            const tarif_data = {
                data: data,
                type_prestation: type_prestation
            }
            this.$emit('emitTarifChambre', tarif_data)
        },

        saveTarifChambre() {
            
            this.editing_chambre_tarif_data.type_prestation = 'chambre'
            this.$store.dispatch("saveTarifTypeAdmission", this.editing_chambre_tarif_data).then((response) => {
                if (response.success) {
                    const data = {
                        assurance_id: this.assurance_select.compagnie_id,
                        data_type: 'chambre'
                    }
                    this.getListeChambre(data)

                    this.$emit('emitCloseTarifModal')
                } else {
                    if (response.code == 401) {
                        this.errorToast("Une erreur s'est produite ! Merci de réessayer plustard.")
                    } else if (response.code == 500) {
                        this.errorToast("Une erreur s'est produite !")
                    }
                }
                this.save_loading = false
                this.btn_disable = false
            })
        },

        printTarifChambre() {
            const data = {
                data_type: 'chambre',
                prestations: this.tarif_chambres
            }
            
            this.$emit('emitPrintTarif', data)
        }
    }
}
